import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            知识分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
            按照不同主题浏览专业健康知识，找到您最关心的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}